// sumberPilihan — sumber data siap pakai untuk <PemilihCari> (pola daftar seragam,
// 27 Sep 2026; `docs/POLA_DAFTAR.md`). Tiap `cariX(kata)` mengirim `q` + batas ke
// SERVER dan mengembalikan paling banyak BATAS_PILIHAN baris — tidak pernah
// memuat seluruh tabel ke browser.
//
// ⚠ Nama parameter cari/batas BERBEDA per endpoint (warisan tiga konvensi); itulah
//   gunanya berkas ini: layar cukup memanggil `cariCustomer`, bukan menghafalnya.
import { api } from "./api";

export const BATAS_PILIHAN = 20;

const items = (r) => r?.data?.items || [];

// ---- Customer: GET /customers?q=&limit= (nama / nomor telepon) ----------------
export const cariCustomer = async (kata) =>
  items(await api.get("/customers", { params: { q: kata || undefined, limit: BATAS_PILIHAN } }));
export const ambilCustomer = async (id) => (await api.get(`/customers/${id}`)).data;
export const labelCustomer = (c) => c?.name || "—";
export const ketCustomer = (c) => [c?.phone, c?.store?.name || c?.city].filter(Boolean).join(" · ") || "—";

// ---- Bahan: GET /inventory/materials?q=&page_size= (kode / nama) -------------
export const cariBahan = async (kata, saring = { is_active: true }) =>
  items(await api.get("/inventory/materials", { params: { ...saring, q: kata || undefined, page: 1, page_size: BATAS_PILIHAN } }));
export const labelBahan = (m) => (m ? `${m.code ? `${m.code} · ` : ""}${m.name || ""}` : "—");

// ---- Vendor: GET /purchasing/vendors?q=&page_size= (nama / kode vendor) ------
export const cariVendor = async (kata, saring = { is_active: true }) =>
  items(await api.get("/purchasing/vendors", { params: { ...saring, q: kata || undefined, page: 1, page_size: BATAS_PILIHAN } }));
export const labelVendor = (v) => (v ? `${v.name || ""}${v.vendor_code ? ` (${v.vendor_code})` : ""}` : "—");

// ---- Karyawan: GET /hr/employees?q=&limit= (nama / kode / posisi) -------------
export const cariKaryawan = async (kata, saring = { active: true }) =>
  items(await api.get("/hr/employees", { params: { ...saring, q: kata || undefined, limit: BATAS_PILIHAN } }));
export const labelKaryawan = (e) => (e ? `${e.full_name || ""}${e.employee_code ? ` (${e.employee_code})` : ""}` : "—");
export const ketKaryawan = (e) => [e?.position, e?.region?.name].filter(Boolean).join(" · ");

// ---- Penerimaan barang (GRN): GET /purchasing/grn?q=&page_size= ---------------
export const cariGrn = async (kata, saring = { status: "RECEIVED" }) =>
  items(await api.get("/purchasing/grn", { params: { ...saring, q: kata || undefined, page: 1, page_size: BATAS_PILIHAN } }));
export const labelGrn = (g) => (g ? `${g.receipt_number || "—"} · ${g.po?.po_number || "—"}` : "—");
export const ketGrn = (g) => g?.po?.vendor?.name || "—";

// ---- WO: GET /wo?q=&page_size= (nomor WO) ------------------------------------
export const cariWo = async (kata, saring = {}) =>
  items(await api.get("/wo", { params: { ...saring, q: kata || undefined, page: 1, page_size: BATAS_PILIHAN } }));
export const labelWo = (w) => w?.wo_number || "—";

// ---- Purchasing (28 Sep 2026): satu vendor per id, dan PO lewat cari ---------
export const ambilVendor = async (id) => (await api.get(`/purchasing/vendors/${id}`)).data;
export const ambilBahan = async (id) => (await api.get(`/inventory/materials/${id}`)).data;
// PO: GET /purchasing/po?q=&page_size= (nomor PO / nama vendor / nomor PR).
//   `saring` mis. { vendor_id, status_in: "ISSUED,PARTIAL_RECEIVED" } atau { belum_selesai: true }.
export const cariPo = async (kata, saring = {}) =>
  items(await api.get("/purchasing/po", { params: { ...saring, q: kata || undefined, page: 1, page_size: BATAS_PILIHAN } }));
export const ambilPo = async (id) => (await api.get(`/purchasing/po/${id}`)).data;
export const labelPo = (p) => p?.po_number || "—";
export const ketPo = (p) => [p?.vendor?.name, p?.region?.name].filter(Boolean).join(" · ") || "—";

// ---- Inventori (28 Sep 2026): lot kain lewat cari ---------------------------------
// Lot: GET /inventory/fabric-lots?q=&page_size= (kode lot / roll; `q` = `lot_code`). `saring` mis. { material_id, store_id }.
export const cariLot = async (kata, saring = {}) =>
  items(await api.get("/inventory/fabric-lots", { params: { ...saring, q: kata || undefined, page: 1, page_size: BATAS_PILIHAN } }));
export const labelLot = (l) => l?.lot_code || "—";
export const ketLot = (l) => [l?.material?.name, l?.store?.name,
  l?.received_at ? `diterima ${String(l.received_at).slice(0, 10)}` : null].filter(Boolean).join(" · ") || "—";
